import { render, staticRenderFns } from "./ColumnMerchantAccess.vue?vue&type=template&id=792c92aa"
import script from "./ColumnMerchantAccess.vue?vue&type=script&lang=js"
export * from "./ColumnMerchantAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports